import { isMCQ, isFRQ } from '../progressHelpers';

const checkIfNoSecureQuestions = (
  { questions = [], isPracticeExam },
  hasPracticeExamBehavior = true,
) => {
  let status = false;

  if (isPracticeExam && hasPracticeExamBehavior) {
    return true;
  }

  //The reason why "some" is used here instead of "foreach" is to break
  // out of the loop when a truthy value is found.
  questions.some((question) => {
    if (isMCQ(question) && !question.isSecure) {
      // it handles non-secure (MCQ)
      status = false;
    } else status = !(isFRQ(question) && !question.isSecure);
    return status;
  });

  return status;
};

export default checkIfNoSecureQuestions;
